import { useMutation } from "@apollo/client";

import { GqlFieldworkerPaymentScope, gql } from "~/__generated__";

import { FIELDWORKER_PAYMENT_GET_ALL } from "./useFiedworkerPaymentGetAll";

const FIELDWORKER_PAYMENT_CREATE = gql(`
mutation FieldworkerPaymentCreate($input: GqlFieldworkerPaymentCreateInput!) {
    fieldworkerPaymentCreate(input: $input) {
        id
        paymentDate
        mediaId
        media {
            id
            name
            mimeType
            isUploaded
            url
        }
        total {
            nightSeconds
            daySeconds
            travelDistanceMeters
        }
        scope
    }
}
`);

export default function useFieldworkerPaymentCreate() {
    const [createPayment, { data, loading, error }] = useMutation(FIELDWORKER_PAYMENT_CREATE, {
        refetchQueries: [FIELDWORKER_PAYMENT_GET_ALL],
    });

    return {
        createPayment: (scope: GqlFieldworkerPaymentScope) => {
            return createPayment({
                variables: {
                    input: {
                        scope,
                    },
                },
            });
        },
        loading,
        error,
        data: data?.fieldworkerPaymentCreate,
    };
}
